import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { HomepageSlider } from "../../../partial-templates/slider/slider.stories";
import { TeaserGatedContent } from "../../../partial-templates/teaser/gated-content/teaser-gated-content.templates";
import { getDummyText, renderPageTemplate } from "../../../../utils";

const getTokenMockUrl = (type) =>
    `./mock-data/gated-content/token-${type}.json`;
const getFormMockUrl = (type) => `./mock-data/gated-content/form-${type}.json`;

export default {
    title: "Website/Page Templates/Integration Examples/Gated Content",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        headline: "Headline Gated Content Overlay",
        buttonText: "Kostenlos registrieren",
        verifyTokenUrl: getTokenMockUrl("valid"),
        formAction: getFormMockUrl("existing"),
        teaserItems: "3",
        contentVideo: false,
    },
    argTypes: {
        buttonText: {
            control: "text",
        },
        verifyTokenUrl: {
            control: "select",
            options: [
                getTokenMockUrl("valid"),
                getTokenMockUrl("invalid"),
                getTokenMockUrl("blocked"),
                getTokenMockUrl("error"),
            ],
        },
        formAction: {
            control: "select",
            options: [
                getFormMockUrl("valid"),
                getFormMockUrl("validation"),
                getFormMockUrl("existing"),
                getFormMockUrl("blocked"),
                getFormMockUrl("error"),
            ],
        },
        teaserItems: {
            options: ["1", "2", "3"],
            control: { type: "radio" },
        },
        contentVideo: {
            control: "boolean",
        },
    },
};

const gatedContentTeaserData = [
    {
        headline: "Live Webinar",
        subline: "Wissen in Echtzeit",
        textAlignment: "center",
        text:
            "Unsere Live Webinare bieten exklusive Einblicke, interaktive Lernmöglichkeiten und direkten Austausch mit Experten, um Ihr Verständnis zu vertiefen und Ihre Fähigkeiten zu stärken.",
        shadow: false,
        icon: "info-rounded",
        iconSize: "50",
    },
    {
        headline: "Whitepaper",
        subline: "Profundes Fachwissen kompakt aufbereitet",
        textAlignment: "center",
        text:
            "Unsere Whitepaper liefern präzise Einblicke, fundierte Analysen und praxisnahe Lösungsansätze, um Sie in Ihrer Expertise zu fördern und informierte Entscheidungen zu treffen.",
        shadow: false,
        icon: "documents",
        iconSize: "50",
    },
    {
        headline: "Demo Videos",
        subline: "Innovation hautnah erleben",
        textAlignment: "center",
        text:
            "Unsere Demo-Videos bieten anschauliche Einblicke, klare Anwendungsbeispiele und praktische Demonstrationen, um Ihnen einen realistischen Eindruck zu vermitteln und Ihre Entscheidungsfindung zu erleichtern.",
        shadow: false,
        icon: "info-rounded",
        iconSize: "50",
    },
];

const generateTeaserSlides = (data) => {
    return data.map(
        (teaserData) => html`
            <ux-slider-slide class="ux-u-d-flex">
                ${TeaserGatedContent(teaserData)}
            </ux-slider-slide>
        `
    );
};

const Template = (args) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row ux-u-mb-fluid-xl">
                <div class="ux-col">
                    ${HomepageSlider()}
                </div>
            </div>

            <div class="ux-row">
                <div class="ux-col">
                    <ux-iws-gated-content
                        verify-token-url="${args.verifyTokenUrl}"
                        button-text="${args.buttonText}"
                    >
                        <div
                            slot="overlay-content"
                            class="ux-u-mb-fluid-xxs ux-u-margin-l-bottom-20"
                        >
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    <h3>${args.headline}</h3>
                                </div>
                            </div>
                            <ux-slider
                                slides-auto-height
                                effect="slide"
                                visible-slides-s="1"
                                visible-slides-m="1"
                                visible-slides-l="1"
                                visible-slides-xl="${args.teaserItems}"
                                container-width-s="83.33%"
                                container-width-m="83.33%"
                                container-width-l="83.33%"
                                container-width-xl="83.33%"
                                space-between-s="60"
                                space-between-m="60"
                                space-between-l="110"
                                space-between-xl="30"
                                breakpoint-l="1279"
                                slides-overflow-visible
                                class="ux-u-mt-nxxs"
                            >
                                ${generateTeaserSlides(
                                    gatedContentTeaserData.slice(
                                        0,
                                        Number(args.teaserItems)
                                    )
                                )}
                                <ux-slider-pagination
                                    slot="pagination"
                                    bottom-pagination
                                    class="ux-u-mt-nxxs"
                                ></ux-slider-pagination>
                            </ux-slider>
                        </div>
                        <div slot="form">
                            <div class="ux-row">
                                <div class="ux-col-10 ux-u-offset-1">
                                    <ux-form>
                                        <form action="${args.formAction}">
                                            <ux-input-field
                                                type="email"
                                                label="email"
                                                name="email"
                                                required
                                            ></ux-input-field>
                                            <br />
                                            <ux-button type="submit"
                                                >Absenden</ux-button
                                            >
                                        </form>
                                    </ux-form>
                                </div>
                            </div>
                        </div>
                        <div slot="loading">
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    Willkommen zurück!
                                </div>
                            </div>
                        </div>
                        <div slot="submitting">
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    Wir prüfen Ihre Daten...
                                </div>
                            </div>
                        </div>
                        <div slot="thanks">
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    Noch ein Schritt...
                                </div>
                            </div>
                        </div>
                        <div slot="blocked">
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    Zugriff nicht möglich!
                                </div>
                            </div>
                        </div>
                        <div slot="error">
                            <div class="ux-row">
                                <div
                                    class="ux-col-10 ux-u-offset-1 ux-u-text-align--center"
                                >
                                    Es ist leider ein Fehler aufgetreten.
                                </div>
                            </div>
                        </div>
                        <div slot="content">
                            ${args.contentVideo
                                ? html`
                                      <div class="ux-row">
                                          <div class="ux-col">
                                              <ux-video>
                                                  <video
                                                      controls=""
                                                      preload="none"
                                                  >
                                                      <source
                                                          src="https://trumpf.com/filestorage/TRUMPF_Master/Products/Software/Oseon/Oseon-GO-animation.mp4"
                                                          type="video/mp4"
                                                      />
                                                  </video>
                                              </ux-video>
                                          </div>
                                      </div>
                                  `
                                : ""}
                            <div class="ux-row">
                                <div class="ux-col-10 ux-u-offset-1">
                                    <p>${getDummyText(6000)}</p>
                                </div>
                            </div>
                        </div>
                    </ux-iws-gated-content>
                </div>
            </div>
        </div>
    `;
};

export const Default = (args) =>
    renderPageTemplate(() => Template({ ...args }));
